import { render, staticRenderFns } from "./StatisticsCentreAll.vue?vue&type=template&id=4906150f&scoped=true"
import script from "./StatisticsCentreAll.vue?vue&type=script&lang=js"
export * from "./StatisticsCentreAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4906150f",
  null
  
)

export default component.exports